<template>
  <div class="flex flex-col items-center justify-center p-8 rounded-lg bg-[var(--p-background-100)] shadow-sm">
    <div class="text-center mb-6">
      <Icon name="lucide:alert-circle" class="text-[var(--p-error-500)] text-5xl mb-4" />
      <h3 class="text-xl font-semibold text-[var(--p-text-primary)] mb-2">{{ $t('error.fetch.title') }}</h3>
      <p class="text-[var(--p-text-secondary)] mb-4">{{ $t('error.fetch.message') }}</p>
    </div>
    
    <div class="flex gap-4">      
      <PrimeButton 
        v-if="showHomeButton" 
        @click="navigateToHome" 
        icon="pi pi-home" 
        :disabled="loading"
        severity="secondary"
        :label="$t('error.fetch.goHome')"
      />
      <PrimeButton 
        @click="$emit('retry')" 
        icon="pi pi-refresh" 
        :label="$t('error.fetch.retry')"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  showHomeButton: {
    type: Boolean,
    default: true
  }
});

defineEmits(['retry']);

const router = useRouter();

function navigateToHome() {
  router.push('/');
}
</script>
